// @ts-nocheck
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import useTracking from 'hooks/analytics';

import CircleTile from 'components/common/tile/CircleTile';
import Grid from 'components/common/Grid';

import focusManager from 'support/focus/FocusManager';

import { pageSelected } from 'actions/pageView';

import { getContentRowMetadata } from 'support/analytics/analyticsHelper';

const trackContentEvent = (
  trackEvent,
  { rowTitle, rowPos, rowCol, tag, pageType },
) => {
  const eventData = {
    ...getContentRowMetadata(rowTitle, rowPos, rowCol),
    moduleAction: 'click',
    clickText: `${pageType} carousel - ${tag}`,
  };
  trackEvent(`${pageType} carousel interactions`, eventData);
};

const CircleGrid = ({
  displayTitle,
  title,
  data,
  titleClassName,
  rowPos,
  focusId: focusIdProp,
  className,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const rows = data;

  const [focusId, setFocusId] = useState(focusIdProp);

  useEffect(() => {
    if (focusIdProp) {
      setFocusId(focusIdProp);
    } else {
      setFocusId(focusManager.getNewUniqueId());
    }
  }, [focusIdProp]);

  const renderGridItem = useCallback(
    (item, index) => {
      const tag = item?.tag?.key;
      const pageType = item?.tag?.type.name;

      const onClick = () => {
        dispatch(pageSelected(tag, pageType));
        trackContentEvent(trackEvent, {
          rowTitle: title,
          rowPos,
          rowCol: index + 1,
          tag,
          pageType,
        });
        history.push({
          pathname: `/${pageType}/${tag}`,
        });
      };

      return (
        <CircleTile
          title={item?.displayName}
          focusId={`grid-item-${item?.id}`}
          item={item}
          key={item?.id}
          staticImageSrc={item?.staticImageUrl}
          staticActiveImage={item?.staticActiveImageUrl}
          lottieImageSrc={item?.lottieImageUrl}
          index={index}
          onClick={onClick}
        />
      );
    },
    [dispatch, history, rowPos, title, trackEvent],
  );

  return (
    <React.Fragment>
      {displayTitle && (
        <div className={classNames(titleClassName, 'font-weight-bold')}>
          {title}
        </div>
      )}
      <Grid
        className={className}
        focusId={focusId}
        numCols={6}
        data={rows || []}
        prevBuffer={rows.length}
        nextBuffer={rows.length}
        renderItem={renderGridItem}
      />
    </React.Fragment>
  );
};

CircleGrid.propTypes = {
  displayTitle: PropTypes.bool.isRequired,
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  rowPos: PropTypes.number,
  data: PropTypes.arrayOf(
    (propValue, key, componentName, location, propFullName) => {
      if (propValue[key].id || propValue[key].id === 0) {
        return null;
      }

      return new Error(
        `Invalid prop ${propFullName} supplied to ${componentName}.  Data items must contain an id.`,
      );
    },
  ).isRequired,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

CircleGrid.defaultProps = {
  title: null,
  titleClassName: null,
  rowPos: null,
  focusId: null,
  className: null,
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <CircleGrid {...props} forwardedRef={ref} />
  )),
);
